import { z } from "zod";

export const backofficeModulatorConsumptionResponseSchema = z.object({
  dateMeter: z.coerce.date(),
  powerValue1: z.number().nullable(),
  powerValue2: z.number().nullable(),
  powerValue3: z.number().nullable(),
  powerValue4: z.number().nullable(),
  powerValue5: z.number().nullable(),
  powerValue6: z.number().nullable(),
});

export type BackofficeModulatorConsumptionResponse = z.infer<typeof backofficeModulatorConsumptionResponseSchema>;
